import { useEffect } from 'react';

function setMeta(name, content, attr = 'name') {
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export function useSEO({ title, description, ogImage, lang }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) setMeta('description', description);
    if (title) setMeta('og:title', title, 'property');
    if (description) setMeta('og:description', description, 'property');
    if (ogImage) setMeta('og:image', ogImage, 'property');
    if (lang) document.documentElement.lang = lang;
  }, [title, description, ogImage, lang]);
}
